export default {
  "Tab.Title": "パーソナルデータの取扱いに関する同意事項",
}
